import Select from 'react-select';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import { ListFiltersContainer } from '../styles';
import { CustomStyle } from '../../../components/CustomSelectStyle';
import { Dispatch, SetStateAction } from 'react';
import { ListType } from '../types';

interface DataFiltersInterface {
  setSelectedDestinyWorkplace: Dispatch<SetStateAction<{ value: number | string, label: string }>>;
  setSelectedEmployee: Dispatch<SetStateAction<{ value: number | string, label: string }>>;
  setVisualizationKind: Dispatch<SetStateAction<'cwp' | 'dwp' | 'employees'>>;
  visualizationKind: 'cwp' | 'dwp' | 'employees';
  setSelectedCurrentWorkplace: Dispatch<SetStateAction<{ value: number | string, label: string }>>;
  selectedCurrentWorkplace: { value: number | string, label: string };
  currentWorkplaceList: ListType;
  handleCurrentWorkplaceChange: (value: { value: string | number, label: string }) => void;
  isLoading: boolean;
  selectedDestinyWorkplace: { value: number | string, label: string };
  destinyWorkplaceList: ListType;
  handleDestinyWorkplaceChange: (value: { value: string | number, label: string }) => void;
  selectedEmployee: { value: number | string, label: string };
  employeesList: ListType;
  handleEmployeeChange: (value: { value: string | number, label: string }) => void;
}

export default function DataFilters({
  setSelectedDestinyWorkplace,
  setSelectedEmployee,
  setVisualizationKind,
  visualizationKind,
  setSelectedCurrentWorkplace,
  selectedCurrentWorkplace,
  currentWorkplaceList,
  handleCurrentWorkplaceChange,
  isLoading,
  selectedDestinyWorkplace,
  destinyWorkplaceList,
  handleDestinyWorkplaceChange,
  selectedEmployee,
  employeesList,
  handleEmployeeChange,
}: DataFiltersInterface) {
  return (
    <ListFiltersContainer>
      <div>
        <h1>
          Visualizar por:
        </h1>

        <FilterRadioButtonsContainer>
          <FilterRadioButton
            onClick={() => {
              setVisualizationKind('cwp');
              setSelectedDestinyWorkplace({ value: 0, label: 'Selecione um Local de trabalho de destino (indicado)' });
              setSelectedEmployee({ value: 0, label: 'Selecione um funcionário' });
            }}
            selected={visualizationKind === 'cwp'}
          >
                        Local de Trabalho (origem)
          </FilterRadioButton>
          <FilterRadioButton
            onClick={() => {
              setVisualizationKind('dwp');
              setSelectedCurrentWorkplace({ value: 0, label: 'Selecione um Local de trabalho de origem (atual)' });
              setSelectedEmployee({ value: 0, label: 'Selecione um funcionário' });
            }}
            selected={visualizationKind === 'dwp'}
          >
                        Local de Trabalho (destino)
          </FilterRadioButton>
          <FilterRadioButton
            onClick={() => {
              setVisualizationKind('employees');
              setSelectedCurrentWorkplace({ value: 0, label: 'Selecione um Local de trabalho de origem (atual)' });
              setSelectedDestinyWorkplace({ value: 0, label: 'Selecione um Local de trabalho de destino (indicado)' });
            }}
            selected={visualizationKind === 'employees'}
          >
                        Funcionário
          </FilterRadioButton>
        </FilterRadioButtonsContainer>

        {visualizationKind === 'cwp' && (
          <span>
                      Selecione um local de trabalho de origem na lista ao lado para visualizar todos os funcionários que trabalham nele atualmente.
          </span>
        )}
        {visualizationKind === 'dwp' && (
          <span>
                      Selecione um local de trabalho de destino na lista ao lado para visualizar todos os funcionários que podem ser remanejados para ele.
          </span>
        )}
        {visualizationKind === 'employees' && (
          <span>
                      Selecione um funcionário na lista ao lado para visualizar seu local de trabalho atual, e os locais de trabalho indicados para remanejamento.
          </span>
        )}
      </div>

      {visualizationKind === 'cwp' && (
        <div className="selectContainer">
          <Select
            value={{ value: selectedCurrentWorkplace.value, label: selectedCurrentWorkplace.label }}
            options={currentWorkplaceList}
            onChange={(opt) => handleCurrentWorkplaceChange(opt!)}
            styles={CustomStyle}
            isDisabled={isLoading}
            classNamePrefix="react-select"
            className="react-select-container"
          />
        </div>
      )}
      {visualizationKind === 'dwp' && (
        <div className="selectContainer">
          <Select
            value={{ value: selectedDestinyWorkplace.value, label: selectedDestinyWorkplace.label }}
            options={destinyWorkplaceList}
            onChange={(opt) => handleDestinyWorkplaceChange(opt!)}
            styles={CustomStyle}
            isDisabled={isLoading}
            classNamePrefix="react-select"
            className="react-select-container"
          />
        </div>
      )}
      {visualizationKind === 'employees' && (
        <div className="selectContainer">
          <Select
            value={{ value: selectedEmployee.value, label: selectedEmployee.label }}
            options={employeesList}
            onChange={(opt) => handleEmployeeChange(opt!)}
            styles={CustomStyle}
            isDisabled={isLoading}
            classNamePrefix="react-select"
            className="react-select-container"
          />
        </div>
      )}
    </ListFiltersContainer>
  );
}
